"use client";

import withProductHOC from "@/HOC/withProductHOC";
import ButtonComponent from "@/Inputs/ButtonComponent";
import { cn, FloatValues } from "@/services/Methods/normalMethods";
import { CircularProgress, Link } from "@mui/material";
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import { notFoundImage } from '@/assets/images';
import Image from "next/image";
import _ from "lodash";
import { useEffect, useState } from "react";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { storeAssigned } from "@/services/Methods/normalMethods";
import { getCurrencySign } from "@/services/Methods/normalMethods";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const ClubViagoLaunchPack = (props) => {
    const { loading, onetime = true, allProductState, _addToCartFunction, activeStep = "", setActiveStep, setStepActive, setpActive, setAddToCartProduct, UserCountry, storeAssignUppercase, userIpCountry, Localkey, setShowPopup, showPopup, storeAssign, setStoreAssign, setSelectedStore, isUserLogin, pathname } = props;
    const [bigPackUnselected, setBigPackUnselected] = useState(false);

    // const titleOrder = {
    //     "Club Viago Plus Pack ": 1,
    //     "Club Viago Plus": 2,
    //     "Club Viágo Standard Pack": 3,
    //     "Club Viágo Standard": 4,
    //     "Club Viago Monthly": 5,
    //     "Club Viago Plus 6": 6,
    // };

    // const sortedProducts = allProductState?.sort((a, b) => {
    //     const orderA = titleOrder[a.title] || Infinity;
    //     const orderB = titleOrder[b.title] || Infinity;
    //     return orderA - orderB;
    // });

    useEffect(() => {
        setAddToCartProduct({ normalProducts: [] });
        localStorageCall().removeItem(`normalProducts`);
        localStorageCall().removeItem('RenewalProduct')
        localStorageCall().removeItem('activeStep');
    }, []);

    const LOCAL_STORAGE_KEY = 'showPopupDismissed';

    useEffect(() => {
        if (storeAssignUppercase && ((storeAssignUppercase !== userIpCountry) && (UserCountry !== storeAssignUppercase)) && !Localkey) {
            setShowPopup(true);
        }
    }, [])
    console.log("UserCountryaaaa", UserCountry, "storeAssignUppercase", storeAssignUppercase, "userIpCountry", userIpCountry, "Localkey", Localkey);

    const handleClose = () => {
        localStorageCall().setItem(LOCAL_STORAGE_KEY, 'true');
        setShowPopup(false);
    };

    console.log("userIpCountryuserIpCountry", userIpCountry, "UserCountryUserCountry", UserCountry);
    return (
        <>
            <div>
                {showPopup && (userIpCountry !== storeAssignUppercase && UserCountry !== storeAssignUppercase) && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-md">
                            {
                                isUserLogin && UserCountry !== storeAssignUppercase && (
                                    <p className="text-gray-800 text-center mb-4">
                                        The Country on your account ({UserCountry}) does not match the store you are shopping ({storeAssign}).
                                    </p>
                                )
                            }
                            {
                                userIpCountry !== storeAssignUppercase && (
                                    <p className="text-gray-800 text-center mb-4">
                                        Your IP ({userIpCountry}) does not match the store you are shopping ({storeAssignUppercase}).
                                    </p>
                                )
                            }


                            <p className="text-gray-800 text-center mb-4">
                                Do you still want to continue?
                            </p>
                            <div className="flex justify-center">
                                <button
                                    style={{
                                        padding: '0.5rem 1rem',
                                        // backgroundColor: '#8dfa00',
                                        color: 'white',
                                        borderRadius: '0.5rem',
                                        // transition: 'background-color 0.2s ease',
                                    }}
                                    onClick={handleClose}
                                    className="px-4 py-2 text-white rounded-lg border-[#8dfa00] bg-[#8dfa00]"
                                >
                                    Continue
                                </button>
                            </div>
                            <div className="text-base/7 font-medium text-[#591069] mb-2 text-center">
                                OR
                            </div>

                            <div>
                                <ButtonComponent onClick={() => {
                                    _.map(['normal', 'distributor'], (row) => {
                                        setSelectedStore((prv) => ({ ...prv, defaultCode: prv?.newCode }))
                                        localStorageCall().setItem(LOCAL_STORAGE_KEY, 'true')
                                        if (_.includes(pathname, 'main-enrollment')) {
                                            if (userIpCountry !== storeAssignUppercase || UserCountry !== userIpCountry) {
                                                window.location.assign(`/${userIpCountry.toLowerCase()}/main-enrollment`)

                                            } else {

                                                window.location.assign(`/${UserCountry.toLowerCase()}/main-enrollment`)

                                            }
                                        } else if (_.includes(pathname, 'products') || _.includes(pathname, 'checkout')) {
                                            if (userIpCountry !== storeAssignUppercase || UserCountry !== userIpCountry) {
                                                window.location.assign(`/${userIpCountry.toLowerCase()}/products`)

                                            } else {

                                                window.location.assign(`/${UserCountry.toLowerCase()}/products`)

                                            }
                                        } else {
                                            if (userIpCountry !== storeAssignUppercase || UserCountry !== userIpCountry) {
                                                window.location.assign(`/${userIpCountry.toLowerCase()}`)
                                            } else {
                                                window.location.assign(`/${UserCountry.toLowerCase()}`)


                                            }
                                        }
                                    })
                                }}>
                                    Change {storeAssign} <ArrowRightAltIcon />  {isUserLogin && UserCountry === userIpCountry ? UserCountry : userIpCountry}
                                </ButtonComponent>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <h3 className='text-center py-3'>{bigPackUnselected ? 'Options Pack' : 'Club Viago Launch Pack'}</h3>
            {loading ? (
                <div className="loder_div">
                    <CircularProgress className='' />
                </div>
            ) : (
                <div className="w-full text-center flex-col">
                    {/* {!bigPackUnselected && (
                        <Link
                            component="button"
                            underline="hover"
                            variant="body2"
                            color='info'
                            className="text-[16px] no_thaks_btn"
                            onClick={() => setBigPackUnselected(true)}
                        >
                            No thanks. Continue
                        </Link>
                    )} */}
                    <div className='w-full my-0 mx-auto flex flex-col ambester_products'>
                        {allProductState?.length > 0 ? (
                            _.map(allProductState, ({ points, id, image, title, price, stock, out_of_stock, category_id, product_content, ...row }, index) => (
                                // (bigPackUnselected ? !_.includes(['Club Viágo Launch Pack', 'Ambassador Registration Fee'], title) : (title === "Club Viágo Launch Pack")) && (
                                <div
                                    key={"Allproduct" + index}
                                    className="rounded-[0px] bg-[#fff] pt-[22px] p-[22px] flex flex-col border-solid border-2 border-[rgba(0,0,0,.125)] md:mx-[18px] md:my-[18px] mx-[0px] my-[10px]"
                                >
                                    <div className="flex items-center">
                                        <div
                                            className="max-w-[150px] mr-[20px] mb-[20px] w-full flex items-center justify-center cursor-pointer"
                                        >
                                            {image ? (
                                                <img src={image} className="w-full h-full object-contain" alt="product" />
                                            ) : (
                                                <Image src={notFoundImage} alt="Image 10" className="w-full h-full object-contain" />
                                            )}
                                        </div>
                                        <div className="w-full">
                                            <h3 className="xl:text-[24px] md:text-[17px] sm:text-[16px] text-lg font-normal text uppercase leading-[1.43]">
                                                {title}
                                            </h3>
                                        </div>
                                    </div>
                                    {/* {!bigPackUnselected && ( */}
                                    {product_content && (
                                        // <h1 className="py-3 text-start text-[60px] leading-[90px] font-bold max-w-[866px]">
                                        //     This is the most amazing pack eva!!!
                                        // </h1>

                                        <div dangerouslySetInnerHTML={{ __html: product_content }}></div>
                                        // product_content
                                    )}
                                    <div className="flex flex-col justify-between flex-1">
                                        <div className="btn-group w-full text-center">
                                            {(() => {
                                                let oneTimePrice = row['normal_oneTime'] || price;
                                                return (
                                                    <>
                                                        {onetime && (
                                                            <div className={cn(`block w-full text-start max-w-[max-content] text-black xl:text-[24px] sm:text-[20px] text-[20px] font-semibold transtion-all duration-300 ease-in-out`, 'oneTime')}
                                                            >
                                                                {getCurrencySign(_.upperCase(storeAssigned()))}{FloatValues(oneTimePrice)}
                                                            </div>
                                                        )}
                                                        <ButtonComponent
                                                            classes={"xl:mb-0 lg:mb-0  mb-0 rounded-[0px] py-[7.5px] px-[20px] max-w-[196px] ml-auto flex justify-end gap-[23px] items-center bg-[#fff] text-[#444] border-0 hover:border-0"}
                                                            type="button"
                                                            onClick={() => {
                                                                if (process.env.NEXT_PUBLIC_COMING_SOON !== 'true') {
                                                                    _addToCartFunction(id, 'oneTime', category_id);
                                                                    setActiveStep(activeStep + 1);
                                                                }
                                                            }}
                                                        >
                                                            <p className='text-[18px] text-[#444] leading-[1.93]'>Select</p>
                                                            <TrendingFlatIcon />
                                                        </ButtonComponent>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                // )
                            ))
                        ) : (
                            <div className="flex justify-center items-center w-full text-[18px] col-span-full">No Product Found</div>
                        )}
                    </div>
                    {!bigPackUnselected ? (
                        <Link
                            component="button"
                            underline="hover"
                            variant="body2"
                            color='info'
                            className="text-[16px] no_thaks_btn"
                            onClick={() => { setBigPackUnselected(true), setStepActive(setpActive + 1) }}
                        >
                            No thanks. Continue
                        </Link>
                    ) :
                        <Link
                            component="button"
                            underline="hover"
                            variant="body2"
                            color='info'
                            className="text-[16px] no_thaks_btn"
                            onClick={() => {
                                setActiveStep(activeStep + 1);
                                setStepActive(setpActive + 1)
                                // setBigPackUnselected(false)
                            }}
                        >
                            No thanks. Continue
                        </Link>
                    }
                </div>
            )}
        </>
    );
}

export default withProductHOC(ClubViagoLaunchPack, 'normal');
